// extracted by mini-css-extract-plugin
module.exports = {"nav":"glossaryNav-module--nav--1t2p-","ul":"glossaryNav-module--ul--11XHE"};